export enum UsersFlashMessageGroup {
  AddUser = 'add-user',
  AssignRole = 'assign-role',
  RenameUser = 'rename-user'
}
